import useGetNewestBoardPostInfinite from '@/hooks/community/mobile/useGetNewestBoardPostInfinite';
import { newestBoardPostService } from '@/services/community';

const useGetNewestBoardPost = (boardCategoryId?: string) => {
  const {
    data: newestPostsData,
    isLoading: isNewestPostsLoading,
    hasNextPage: hasNewestPostsNextPage,
    fetchNextPage: fetchNewestPostsNextPage,
    refetch: newestPostsDataRefetch,
  } = useGetNewestBoardPostInfinite(
    {
      request: {
        boardCategoryId: boardCategoryId,
        size: 20,
      },
    },
    {
      refetchOnWindowFocus: true,
      refetchInterval: 60 * 1000,
      select: (data) => {
        return {
          pages: newestBoardPostService(data.pages, !!boardCategoryId),
          pageParams: data.pageParams,
        };
      },
    },
  );

  return {
    newestPostsData,
    isNewestPostsLoading,
    hasNewestPostsNextPage,
    fetchNewestPostsNextPage,
    newestPostsDataRefetch,
  };
};

export default useGetNewestBoardPost;
